import type { BarChartProps } from '@mui/x-charts/BarChart'

export const BAR_COUNT = 50
export const TRACKING_TIMEOUT = 2000
export const ACTIVE_COLOR = '#78E4E8'
export const INACTIVE_COLOR = '#EFEFF6'
export const CHART_PROPS = {
    height: 64,
    leftAxis: null,
    bottomAxis: null,
    tooltip: { trigger: 'none' },
    axisHighlight: { x: 'none' },
    disableAxisListener: true,
    margin: { top: 0, right: 0, bottom: 0, left: 0 },
    skipAnimation: true,
} as BarChartProps
